// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* This file is DEPRECATED
   We are moving to the Octopus Design System
   https://www.octopus.design
  
   When changing component styles:
   1. Do not use variables from this file
   2. Aim to use Emotion \`css\` + themeTokens.colors
       - see Dashboard.tsx for example
   3. If you need to use Less, reference CSS variables
       - see index.ejs for example
       - for full list see https://github.com/OctopusDeploy/OctopusDeploy/blob/main/frontend/packages/design-system-tokens/src/generated/themeTokens.ts
   4. Remove variables from this file when they are no longer used
 */
@media (max-width: 37.4rem) {
  .style_hide-sm__ZxKXh {
    display: none !important;
  }
}
@media (min-width: 37.4rem) {
  .style_visible-sm__fnogs {
    display: none !important;
  }
}
@media (max-width: 79.9rem) {
  .style_hide-md__W9y9c {
    display: none !important;
  }
}
@media (min-width: 79.9rem) {
  .style_visible-md__Nr9W2 {
    display: none !important;
  }
}
.style_formExpander__lHlsU,
.style_formNonExpander__w04ZT {
  width: 100%;
  box-shadow: none!important;
  border-radius: 0!important;
  border-style: solid;
  border-width: 0.0625rem 0 0.0625rem 0;
  border-color: var(--colorBorderTertiary);
  border-bottom: none;
}
.style_formExpander__lHlsU > div:first-child,
.style_formNonExpander__w04ZT > div:first-child {
  padding: 0!important;
}
.style_formExpander__lHlsU > div:first-child > div:first-child,
.style_formNonExpander__w04ZT > div:first-child > div:first-child {
  padding: 0.875rem 1rem !important;
}
.style_formExpander__lHlsU > div:first-child > div:first-child {
  cursor: pointer;
}
.style_formSection__mCHEr {
  width: 100%;
  box-shadow: none!important;
}
.style_cardTitleContainer__SNQi6 {
  display: flex;
  align-items: top;
  position: relative;
  word-wrap: break-word;
}
@media (max-width: 37.4rem) {
  .style_cardTitleContainer__SNQi6 {
    display: block;
  }
}
.style_cardTitleContainerForceMobile__HeOp2 {
  display: flex;
  align-items: top;
  position: relative;
  word-wrap: break-word;
  display: block;
}
@media (max-width: 37.4rem) {
  .style_cardTitleContainerForceMobile__HeOp2 {
    display: block;
  }
}
.style_cardTitle__OqM8M {
  top: 1rem;
  width: 15rem !important;
  min-width: 15rem !important;
  min-height: 1.5rem !important;
  font-family: Roboto !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  line-height: 1.5 !important;
  text-align: right !important;
  color: var(--colorTextPrimary) !important;
}
@media (max-width: 37.4rem) {
  .style_cardTitle__OqM8M {
    text-align: left !important;
    position: static !important;
  }
}
.style_cardTitleForceMobile__ZJHop {
  top: 1rem;
  width: 15rem !important;
  min-width: 15rem !important;
  min-height: 1.5rem !important;
  font-family: Roboto !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  line-height: 1.5 !important;
  text-align: right !important;
  color: var(--colorTextPrimary) !important;
  text-align: left !important;
  position: static !important;
}
@media (max-width: 37.4rem) {
  .style_cardTitleForceMobile__ZJHop {
    text-align: left !important;
    position: static !important;
  }
}
.style_cardSubTitle__Lvvtx,
.style_cardPlaceholderSubTitle__CC3dv,
.style_cardDefaultSubTitle__cpTLE {
  font-family: Roboto !important;
  font-size: 1rem !important;
  line-height: 1.5 !important;
  text-align: left !important;
  color: var(--colorTextPrimary) !important;
  margin-left: 1.6rem !important;
  margin-right: 2rem !important;
  display: block !important;
  word-wrap: break-word;
  min-width: 50%;
}
@media (max-width: 37.4rem) {
  .style_cardSubTitle__Lvvtx,
  .style_cardPlaceholderSubTitle__CC3dv,
  .style_cardDefaultSubTitle__cpTLE {
    margin-left: 0rem !important;
  }
}
.style_cardSubTitle__Lvvtx > div > p {
  margin: 0;
}
.style_cardSubTitleForceMobile__VRhKF {
  font-family: Roboto !important;
  font-size: 1rem !important;
  line-height: 1.5 !important;
  text-align: left !important;
  color: var(--colorTextPrimary) !important;
  margin-left: 1.6rem !important;
  margin-right: 2rem !important;
  display: block !important;
  word-wrap: break-word;
  min-width: 50%;
  margin-left: 0rem !important;
}
@media (max-width: 37.4rem) {
  .style_cardSubTitleForceMobile__VRhKF {
    margin-left: 0rem !important;
  }
}
.style_cardSubTitleForceMobile__VRhKF > div > p {
  margin: 0;
}
.style_cardSubTitleWithOverflowMenu__wa80f {
  margin-right: 3rem !important;
}
.style_cardPlaceholderSubTitle__CC3dv {
  color: var(--colorTextTertiary) !important;
}
.style_cardDefaultSubTitle__cpTLE::after {
  content: " (default)";
  color: var(--colorTextTertiary) !important;
}
.style_cardMedia__rD5bZ {
  margin-left: 17.6rem;
  margin-right: 4rem;
  margin-top: -0.5rem;
  padding-bottom: 1rem;
  max-width: 37.5rem;
}
@media (max-width: 37.4rem) {
  .style_cardMedia__rD5bZ {
    margin-left: 1.1rem !important;
    margin-right: 1.1rem;
  }
}
.style_cardMediaForceMobile__Hh3Wy {
  margin-left: 17.6rem;
  margin-right: 4rem;
  margin-top: -0.5rem;
  padding-bottom: 1rem;
  max-width: 37.5rem;
  margin-left: 1.1rem !important;
  margin-right: 1.1rem;
}
@media (max-width: 37.4rem) {
  .style_cardMediaForceMobile__Hh3Wy {
    margin-left: 1.1rem !important;
    margin-right: 1.1rem;
  }
}
.style_cardMediaFillRight__cUiYg {
  max-width: none;
}
.style_cardMediaFillAll__q16lR {
  margin-left: 0;
  margin-right: 0;
}
.style_cardMedia__rD5bZ .style_container__NUSjd {
  padding-bottom: 0.5rem !important;
}
.style_cardMediaNonExpander__BTRZu {
  margin: 0 1.1rem;
  padding: 1rem 0;
}
.style_expandLink__PjpT0 {
  width: 6rem;
  height: 1.19rem;
  font-family: Roboto;
  font-size: 0.8125rem;
  line-height: 1.36rem;
  color: var(--colorTextTertiary);
  margin-right: 1.5rem;
}
.style_expandLink__PjpT0:hover {
  color: var(--colorTextLinkDefault);
}
.style_linkContainer__KqyLd {
  width: 100%;
  text-align: right;
  padding: 0.3125rem 0;
}
.style_moreInformation__zaFrE {
  padding: 1rem;
  background: var(--colorBackgroundPrimaryHover);
  font-size: 0.875rem;
}
.style_hide__ZZtdH {
  font-family: Roboto;
  font-size: 0.75rem;
  line-height: 1.83rem;
  text-align: left;
  color: var(--colorTextTertiary);
  text-align: right;
}
.style_hide__ZZtdH a {
  color: var(--colorTextLinkDefault);
}
.style_sectionHeading__rgDtf {
  width: 100%;
  background: var(--colorBackgroundPrimaryHover);
  border-radius: 0!important;
  border-style: solid;
  border-width: 0.0625rem 0 0.0625rem 0;
  border-color: var(--colorBorderTertiary);
  margin: 0 0 -0.0725rem 0;
}
.style_dialogSectionHeading__lRF68 {
  background: var(--colorBackgroundPrimaryHover);
  margin: 2rem -1rem 1rem;
  border-style: solid;
  border-width: 0.0625rem 0;
  border-color: var(--colorBorderTertiary);
}
.style_sectionHeadingTitle__RZFhN {
  padding: 0.6rem 1rem;
  font-size: 1.0625rem;
}
.style_overflowMenuActions__Z5nk7 {
  margin-left: auto;
  padding-right: 2.25rem;
  align-items: center;
}
.style_expandCollapse__PKry1 {
  top: 0;
  bottom: 0;
  right: 0.25rem;
  position: absolute;
}
`, "",{"version":3,"sources":["webpack://./app/components/form/Sections/style.less","webpack://./app/resources/styles/media.less"],"names":[],"mappings":"AAAA;;;;;;;;;;;;EAYE;ACNF;EACE;IACE,wBAAA;EDQF;AACF;ACLA;EACE;IACE,wBAAA;EDOF;AACF;ACJA;EACE;IACE,wBAAA;EDMF;AACF;ACJA;EACE;IACE,wBAAA;EDMF;AACF;AAfA;;EAXI,WAAA;EACA,0BAAA;EAIA,0BAAA;EACA,mBAAA;EACA,qCAAA;EACA,wCAAA;EAMA,mBAAA;AAsBJ;AAzBA;;EAMQ,oBAAA;AAuBR;AA7BA;;EAQY,iCAAA;AAyBZ;AApBA;EAGY,eAAA;AAoBZ;AAfI;EAhCA,WAAA;EACA,0BAAA;AAkDJ;AAfI;EACI,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AAiBR;AAhBQ;EAAA;IACI,cAAA;EAmBV;AACF;AAjBI;EARI,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EAOA,cAAA;AAsBR;AA5BQ;EAAA;IACI,cAAA;EA+BV;AACF;AAFI;EACI,SAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;EACA,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,4BAAA;EACA,yCAAA;AAIR;AAHQ;EAAA;IACI,2BAAA;IACA,2BAAA;EAMV;AACF;AAJI;EAfI,SAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;EACA,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,4BAAA;EACA,yCAAA;EAQA,2BAAA;EACA,2BAAA;AAeR;AAvBQ;EAAA;IACI,2BAAA;IACA,2BAAA;EA0BV;AACF;AAlBI;;;EACI,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,yCAAA;EACA,8BAAA;EACA,6BAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;AAsBR;AArBQ;EAAA;;;IACI,4BAAA;EA0BV;AACF;AAvCI;EAeQ,SAAA;AA2BZ;AAxBI;EAjBI,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,yCAAA;EACA,8BAAA;EACA,6BAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EAUA,4BAAA;AAmCR;AA5CQ;EAAA;IACI,4BAAA;EA+CV;AACF;AA1CI;EAHQ,SAAA;AAgDZ;AAzCI;EACI,6BAAA;AA2CR;AAxCI;EAEI,0CAAA;AAyCR;AAlCI;EACI,qBAAA;EACA,0CAAA;AAoCR;AAjCI;EACI,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;AAmCR;AAlCQ;EAAA;IACI,8BAAA;IACA,oBAAA;EAqCV;AACF;AAnCI;EAVI,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EAQA,8BAAA;EACA,oBAAA;AAyCR;AAjDQ;EAAA;IACI,8BAAA;IACA,oBAAA;EAoDV;AACF;AA5CI;EACI,eAAA;AA8CR;AA3CI;EACI,cAAA;EACA,eAAA;AA6CR;AA1CI;EACI,iCAAA;AA4CR;AAzCI;EAEI,gBAAA;EACA,eAAA;AA0CR;AAvCI;EACI,WAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,+BAAA;EACA,oBAAA;AAyCR;AAtCI;EACI,kCAAA;AAwCR;AArCI;EACI,WAAA;EACA,iBAAA;EACA,oBAAA;AAuCR;AApCI;EACI,aAAA;EACA,8CAAA;EACA,mBAAA;AAsCR;AAnCI;EACI,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,+BAAA;EAIA,iBAAA;AAkCR;AA3CI;EAOQ,kCAAA;AAuCZ;AAlCM;EACE,WAAA;EACA,8CAAA;EA7MJ,0BAAA;EACA,mBAAA;EACA,qCAAA;EACA,wCAAA;EA4MI,wBAAA;AAuCR;AApCM;EACE,8CAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,wCAAA;AAsCR;AAnCM;EACE,oBAAA;EACA,oBAAA;AAqCR;AAlCM;EAME,iBAAA;EACA,sBAAA;EACA,mBAAA;AA+BR;AA5BM;EACE,MAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;AA8BR","sourcesContent":["@import \"../../../resources/styles/variables\";\n@import \"../../../resources/styles/colors\";\n@import \"../../../resources/styles/media\";\n\n\n.formSectionBase() {\n    width: 100%;\n    box-shadow: none!important;\n}\n\n.formSectionBorder() {\n    border-radius: 0!important;\n    border-style: solid;\n    border-width: 0.0625rem 0 0.0625rem 0;\n    border-color: @divider;\n}\n\n.formExpander, .formNonExpander {\n    .formSectionBase();\n    .formSectionBorder();\n    border-bottom: none;\n\n    > div:first-child {\n        padding: 0!important;\n        > div:first-child {\n            padding: 0.875rem 1rem!important;\n        }\n    }\n}\n\n.formExpander {\n    > div:first-child {\n        > div:first-child {\n            cursor: pointer;\n        }\n    }\n}\n\n    .formSection {\n        .formSectionBase();\n    }\n\n    .cardTitleContainer {\n        display: flex;\n        align-items: top;\n        position: relative; // anchor for .expandCollapse (position: absolute). MUI Card used to provide this.\n        word-wrap: break-word; // mark.siedle - Needed on settings page for long setting keys to wrap properly.\n        @media (max-width: @screen-sm) {\n            display:block;\n        }\n    }\n    .cardTitleContainerForceMobile {\n        .cardTitleContainer;\n        display:block;\n    }\n\n    // // todo: this probably isn't the right solution. make this css better\n    // // Work with someone from frontend to make this better\n    // .dialogCardTitle {\n    //     top: 1rem;\n    //     min-height: 1.5rem !important;\n    //     font-family: Roboto !important;\n    //     font-size: 1rem !important;\n    //     font-weight: @bold !important;\n    //     line-height: 1.5 !important;\n    //     text-align: right !important;\n    //     color: @primaryText !important;\n    //     @media (max-width: @screen-sm) {\n    //         text-align: left !important;\n    //         position: static !important;\n    //     }\n    // }\n    // .dialogCardTitleForceMobile {\n    //     .dialogCardTitle;\n    //     text-align: left !important;\n    //     position: static !important;\n    // }\n\n    .cardTitle {\n        top: 1rem;\n        width: 15rem !important;\n        min-width: 15rem !important;\n        min-height: 1.5rem !important;\n        font-family: Roboto !important;\n        font-size: 1rem !important;\n        font-weight: @bold !important;\n        line-height: 1.5 !important;\n        text-align: right !important;\n        color: @primaryText !important;\n        @media (max-width: @screen-sm) {\n            text-align: left !important;\n            position: static !important;\n        }\n    }\n    .cardTitleForceMobile {\n        .cardTitle;\n        text-align: left !important;\n        position: static !important;\n    }\n\n    .cardSubTitle {\n        font-family: Roboto !important;\n        font-size: 1rem !important;\n        line-height: 1.5 !important;\n        text-align: left !important;\n        color: @primaryText !important;\n        margin-left: 1.6rem !important;\n        margin-right: 2rem !important;\n        display: block !important;\n        word-wrap: break-word;\n        min-width: 50%; // ie and firefox require flex children to have a min-width for word-wrap to work https://stackoverflow.com/questions/36150458/flex-item-overflows-container-due-to-long-word-even-after-using-word-wrap\n        @media (max-width: @screen-sm) {\n            margin-left: 0rem !important;\n        }\n        > div > p { // our markdown renderer wraps a div then a p around text which has a bunch of top/bottom margin\n            margin: 0;\n        }\n    }\n    .cardSubTitleForceMobile {\n        .cardSubTitle;\n        margin-left: 0rem !important;\n    }\n    .cardSubTitleWithOverflowMenu {\n        margin-right: 3rem !important;\n    }\n\n    .cardPlaceholderSubTitle {\n        &:extend(.cardSubTitle);\n        color: @secondaryText !important;\n    }\n\n    .cardDefaultSubTitle{\n        &:extend(.cardSubTitle);\n    }\n\n    .cardDefaultSubTitle::after {\n        content: \" (default)\";\n        color: @secondaryText !important;\n    }\n\n    .cardMedia {\n        margin-left: 17.6rem;\n        margin-right: 4rem;\n        margin-top:-0.5rem;\n        padding-bottom: 1rem;\n        max-width:37.5rem;\n        @media (max-width: @screen-sm) {\n            margin-left: 1.1rem !important;\n            margin-right: 1.1rem;\n        }\n    }\n    .cardMediaForceMobile {\n        .cardMedia;\n        margin-left: 1.1rem !important;\n        margin-right: 1.1rem;\n    }\n\n    .cardMediaFillRight {\n        max-width: none;\n    }\n\n    .cardMediaFillAll {\n        margin-left: 0;\n        margin-right: 0;\n    }\n\n    .cardMedia .container {\n        padding-bottom: 0.5rem !important;\n    }\n\n    .cardMediaNonExpander\n    {\n        margin: 0 1.1rem;\n        padding: 1rem 0;\n    }\n\n    .expandLink {\n        width: 6rem;\n        height: 1.19rem;\n        font-family: Roboto;\n        font-size: 13/16rem;\n        line-height: 1.36rem;\n        color: @secondaryText;\n        margin-right: 1.5rem;\n    }\n\n    .expandLink:hover {\n        color: @primary;\n    }\n\n    .linkContainer {\n        width: 100%;\n        text-align: right;\n        padding: 5/16rem 0;\n    }\n\n    .moreInformation {\n        padding: 1rem;\n        background: @hover;\n        font-size: 14/16rem;\n    }\n\n    .hide {\n        font-family: Roboto;\n        font-size: 0.75rem;\n        line-height: 1.83rem;\n        text-align: left;\n        color: @secondaryText;\n        a {\n            color: @primary;\n        }\n        text-align: right;\n      }\n\n      .sectionHeading {\n        width:100%;\n        background: @hover;\n        .formSectionBorder();\n        margin: 0 0 -0.0725rem 0;\n      }\n\n      .dialogSectionHeading {\n        background: @hover;\n        margin: 2rem -1rem 1rem;\n        border-style: solid;\n        border-width: 0.0625rem 0;\n        border-color: @divider;\n      }\n\n      .sectionHeadingTitle {\n        padding: 0.6rem 1rem;\n        font-size: 17/16rem;\n      }\n\n      .overflowMenuActions {\n        // top: 0;\n        // bottom: 0;\n        // right: 2.25rem; // Makes room for the expand/collapse icon next to it.\n        // position: absolute;\n        // padding-top: 0.5rem; // This helps match the padding around the expand/collapse icon.\n        margin-left: auto;\n        padding-right: 2.25rem;\n        align-items: center;\n      }\n\n      .expandCollapse {\n        top: 0;\n        bottom: 0;\n        right: 0.25rem;\n        position: absolute;\n      }","//@screen-xs: 480px;\n@screen-sm: 37.4rem; //600px\n@screen-md: 79.9rem; //1279px\n//@screen-lg-min: 1280px;\n//@scree-xl-min: 1920px;\n\n@media (max-width: @screen-sm) {\n  .hide-sm {\n    display: none !important;\n  }\n}\n\n@media (min-width: @screen-sm) {\n  .visible-sm {\n    display: none !important;\n  }\n}\n\n@media (max-width: @screen-md) {\n  .hide-md {\n    display: none !important;\n  }\n}\n@media (min-width: @screen-md) {\n  .visible-md {\n    display: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hide-sm": `style_hide-sm__ZxKXh`,
	"hideSm": `style_hide-sm__ZxKXh`,
	"visible-sm": `style_visible-sm__fnogs`,
	"visibleSm": `style_visible-sm__fnogs`,
	"hide-md": `style_hide-md__W9y9c`,
	"hideMd": `style_hide-md__W9y9c`,
	"visible-md": `style_visible-md__Nr9W2`,
	"visibleMd": `style_visible-md__Nr9W2`,
	"formExpander": `style_formExpander__lHlsU`,
	"formNonExpander": `style_formNonExpander__w04ZT`,
	"formSection": `style_formSection__mCHEr`,
	"cardTitleContainer": `style_cardTitleContainer__SNQi6`,
	"cardTitleContainerForceMobile": `style_cardTitleContainerForceMobile__HeOp2`,
	"cardTitle": `style_cardTitle__OqM8M`,
	"cardTitleForceMobile": `style_cardTitleForceMobile__ZJHop`,
	"cardSubTitle": `style_cardSubTitle__Lvvtx`,
	"cardPlaceholderSubTitle": `style_cardPlaceholderSubTitle__CC3dv`,
	"cardDefaultSubTitle": `style_cardDefaultSubTitle__cpTLE`,
	"cardSubTitleForceMobile": `style_cardSubTitleForceMobile__VRhKF`,
	"cardSubTitleWithOverflowMenu": `style_cardSubTitleWithOverflowMenu__wa80f`,
	"cardMedia": `style_cardMedia__rD5bZ`,
	"cardMediaForceMobile": `style_cardMediaForceMobile__Hh3Wy`,
	"cardMediaFillRight": `style_cardMediaFillRight__cUiYg`,
	"cardMediaFillAll": `style_cardMediaFillAll__q16lR`,
	"container": `style_container__NUSjd`,
	"cardMediaNonExpander": `style_cardMediaNonExpander__BTRZu`,
	"expandLink": `style_expandLink__PjpT0`,
	"linkContainer": `style_linkContainer__KqyLd`,
	"moreInformation": `style_moreInformation__zaFrE`,
	"hide": `style_hide__ZZtdH`,
	"sectionHeading": `style_sectionHeading__rgDtf`,
	"dialogSectionHeading": `style_dialogSectionHeading__lRF68`,
	"sectionHeadingTitle": `style_sectionHeadingTitle__RZFhN`,
	"overflowMenuActions": `style_overflowMenuActions__Z5nk7`,
	"expandCollapse": `style_expandCollapse__PKry1`
};
module.exports = ___CSS_LOADER_EXPORT___;
